export const profileFields = ({ t, handleVerify, userData }) => {
  return [
    {
      label: t('USERNAME'),
      id: 'UserName'
    },
    {
      label: t('FULLNAME'),
      id: 'FullName'
    },
    {
      label: t('EMAIL'),
      id: 'Email',
      fieldProps: {
        type: 'email'
      }
    },
    {
      label: t('COMPANY_NAME'),
      id: 'CompanyName'
    },
    {
      label: t('TEAM'),
      id: 'Team'
    },
    {
      label: t('PHONE_NO'),
      id: 'PhoneNumber'
    }
  ];
};
